import React from 'react';
import { Edit, useNotify, useRedirect, DeleteButton, SaveButton, Toolbar } from 'react-admin';

import { useTitle } from '@src/hooks/useTitle';
import PricingRulesForm from './PricingRulesForm';

const RESOURCE_NAME = 'resale/pricing';

const PricingRulesEditToolbar = () => (
  <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <SaveButton />
    <DeleteButton />
  </Toolbar>
);

const PricingRulesEdit = () => {
  const { title } = useTitle('Edit Pricing Rule');
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Edit
      title={title}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify('Pricing rule updated successfully', { type: 'success' });
          redirect('list', RESOURCE_NAME);
        },
        onError: (error: unknown) => {
          const message = error instanceof Error ? error.message : 'Failed to update pricing rule';
          notify(`Error: ${message}`, { type: 'error' });
        },
      }}
    >
      <PricingRulesForm toolbar={<PricingRulesEditToolbar />} />
    </Edit>
  );
};

export default PricingRulesEdit;
